import React, {useEffect, useRef, useState} from "react";
import "./OnlineCatBar.scss";
import {useHistory} from "react-router-dom";
import Swiper from "react-id-swiper";



function OnlineCatBar({cats,changeCats}) {
    //hooks
    // const history = useHistory();
    const MyRef = useRef(null);

    useEffect(()=>{
        updateSlider()
        // console.log("DDDDDDD: ")
    },[cats])

    //states
    // const [currentCat,set_currentCat] = useState({})

    const selectCat = (cat) =>{
        changeCats(cat)
    }

    const params = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        rtl : true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const updateSlider = () =>{
        MyRef.current.swiper.update();
    }

    return(
        <div className="online-catBar-container" style={{margin:"8px 8px"}}>
            <div className="store-categories-list">
                {cats.length>0?  <Swiper ref={MyRef}  {...params}>
                    {cats.map(cat=>{
                        return (
                            <div className="catBar-item" onClick={()=>{
                                selectCat(cat)
                            }}>
                                <span>{cat.name}</span>
                            </div>
                        )
                    })}
                </Swiper>:null}
            </div>
        </div>
    )
}

export {OnlineCatBar};
